// extracted by mini-css-extract-plugin
export default {"UserNavDrawer":"styles_UserNavDrawer__SqF0H"};